import React, { useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import GuestNavbar from "components/Navbars/GuestNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import Footer from "components/Footer/Footer.js";

import routes from "routes.js";

import styles from "assets/jss/material-dashboard-pro-react/layouts/quoteStyle.js";

import register from "assets/img/register.jpeg";
import login from "assets/img/login.jpeg";
import lock from "assets/img/lock.jpeg";
import error from "assets/img/clint-mckoy.jpg";
import pricing from "assets/img/bg-pricing.jpeg";
import axios from "axios";

import { getAgencyNameType } from "components/Utils/utils";

const useStyles = makeStyles(styles);

export default function Pages(props) {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [miniActive, setMiniActive] = React.useState(false);
  const [agencyType, setAgencyType] = React.useState("Sanborns");
  const [image, setImage] = React.useState(
    require("assets/img/sidebar-2.jpg").default
  );
  const [color, setColor] = React.useState("blue");
  const [bgColor, setBgColor] = React.useState("black");
  const [logo, setLogo] = React.useState(
    require("assets/img/logo.png").default
  );
  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (localStorage.getItem("userAgencyType") !== null) {
      getAgencyType();
    }
  });
  const { ...rest } = props;
  // ref for the wrapper div
  const wrapper = React.createRef();
  // styles
  const classes = useStyles();
  React.useEffect(() => {
    document.body.style.overflow = "unset";
    // Specify how to clean up after this effect:
    return function cleanup() {};
  });
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/guest") {
        return (
          <Route
            path={prop.layout + prop.path}
            render={(routeProps) => (
              <prop.component {...routeProps} getAgencyType={getAgencyType} />
            )}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  const getBgImage = () => {
    return login;
  };
  const getAgencyType = (type) => {
    const assignType = getAgencyNameType(type);
    setAgencyType(assignType);
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getActiveRoute = (routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  return (
    <div>
      <div className={classes.wrapper} ref={wrapper}>
        <GuestNavbar
          handleDrawerToggle={handleDrawerToggle}
          agencyType={agencyType}
        ></GuestNavbar>
        {localStorage.getItem("userToken") !== null && (
          <Sidebar
            routes={routes}
            logo={logo}
            image={image}
            open={mobileOpen}
            handleDrawerToggle={handleDrawerToggle}
            color={color}
            bgColor={bgColor}
            miniActive={miniActive}
            {...rest}
          />
        )}
        <div id="container-login" className={classes.fullPage}>
          <Switch>
            {getRoutes(routes)}
            <Redirect from="/guest" to="/auth/login-customer" />
          </Switch>
          <Footer color={"#000"} />
        </div>
      </div>
    </div>
  );
}
